import { render } from "./FreezeUpload.vue?vue&type=template&id=7dc85da4&scoped=true&ts=true"
import script from "./FreezeUpload.vue?vue&type=script&lang=ts"
export * from "./FreezeUpload.vue?vue&type=script&lang=ts"

import "./FreezeUpload.vue?vue&type=style&index=0&id=7dc85da4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc85da4"]])

export default __exports__